import { BrandLoader } from "./BrandLoader";

export function Skeleton({ rows = 4, className = "" }: { rows?: number; className?: string }) {
  return (
    <div className={`skeleton-stack ${className}`} aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton-row" style={{ width: `${88 - (i % 3) * 12}%` }} />
      ))}
    </div>
  );
}

type SkeletonPageProps = {
  title?: boolean;
  label?: string;
};

export function SkeletonPage({ title = true, label = "Loading" }: SkeletonPageProps) {
  return (
    <div className="brand-loader-page" role="status" aria-live="polite">
      <BrandLoader size="lg" label={label} />
      {title ? <span className="sr-only">{label}</span> : null}
    </div>
  );
}
